import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useSmoothScroll from './useSmoothScroll';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useSmoothScroll(pathname);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};
export default ScrollToTop;
